import Image from 'app/Components/Shared/Image/image';
import React, {useState, Fragment, useEffect} from 'react';
import {Col, Row, Button} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import CustomerItemComponent from './CustomerItemComponent';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from '../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopupContent from './PopupContent';
import PopUp from '../../../Shared/Popup/PopUp';
import lodash from 'lodash';
import images from '../images/images';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {dwhAccountsForUpdate} from '../dwhReports';
import {getReportParams, report} from '../../../../middleware/report';
import searchIcon from '../images/fill/fill-1.svg';
import searchIcon2x from '../images/fill/fill-1@2x.svg';
import searchIcon3x from '../images/fill/fill-1@3x.svg';
import clearIcon from '../images/clear/clear.svg';
import clearIcon2x from '../images/clear/clear@2x.svg';
import clearIcon3x from '../images/clear/clear@3x.svg';
import closeIcon from '../images/close-btn/x.svg';
import closeIcon2x from '../images/close-btn/x@2x.svg';
import closeIcon3x from '../images/close-btn/x@3x.svg';
const clearIcons = [clearIcon, clearIcon2x, clearIcon3x];
const searchIcons = [searchIcon, searchIcon2x, searchIcon3x];
const closeIcons = [closeIcon, closeIcon2x, closeIcon3x];
import {
  gaReportShownPage,
  gaReportOnButtonClick,
  gaPopupBanSelectingIsOpenedPrivate,
  gaPopupBanSelectingContinueButtonClickedPrivate,
} from './../gaReports';

const AllCustomersComponent = (props) => {
  const {customersList} = props?.data[0];
  const {hiddenNumber, paymentMethod, saveSelectedCustomers} = props;
  const [selectedCustomers, toggleSelected] = useState({items: customersList, count: 0});
  const [selectAllCheckBox, toggleSelectAllCheckBox] = useState(false);
  const [isSelecting, toggleSelecting] = useState(false);
  const [isSelectAllShowPopUp, toggleSelectAllShowPopUp] = useState(false);
  const [isCloseAllShowPopUp, toggleCloseAllShowPopUp] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [isPrivateFlow, setIsPrivateFlow] = useState(true);
  const isBusinessBlock = props.props.data.isBusinessBlock;


  const backgroundImageFromIcons = (icons) => {
    const dpr = window.devicePixelRatio || 1;
    if (dpr >= 3) {
      return icons[2].bg();
    }
    if (dpr >= 2) {
      return icons[1].bg();
    }
    return icons[0].bg();
  };
  
  

  useEffect(() => {
    if (isBusinessBlock) {
      gaReportShownPage('select_customers');
    } else {
      toggleSelecting(true);
      gaPopupBanSelectingIsOpenedPrivate(selectedCustomers.items?.length);
    }

    getSelectedCountOnLoad();
  }, []);

  useEffect(() => {
    if (!isBusinessBlock) {
      selectAll();
      dwhAccountsForUpdate(false);
    } else {
      dwhAccountsForUpdate(true);
    }
  }, []);

  const getSelectedCountOnLoad = () => {
    var results = lodash.filter(customersList, function (customer) {
      return customer.checked == true;
    }).length;

    toggleSelected({...selectedCustomers, count: results});
    customersList?.length == results ? toggleSelectAllCheckBox(true) : toggleSelectAllCheckBox(false);
    if (results > 0) toggleSelecting(true);
  };

  const onToggleCheckBox = (id) => {
    let count;
    const newData = selectedCustomers.items.map((customer) => {
      if (customer.id === id) {
        count = customer.checked == true ? --selectedCustomers.count : ++selectedCustomers.count;
        return {
          ...customer,
          checked: !customer.checked,
        };
      }
      return customer;
    });
    toggleSelected({...selectedCustomers, items: newData, count: count});
    selectedCustomers.items.length == selectedCustomers.count ? toggleSelectAllCheckBox(true) : toggleSelectAllCheckBox(false);
  };

  const selectAll = () => {
    const selectedAlready = selectedCustomers.items.some((customer) => customer.checked == true);

    if (selectedAlready) {
      if (!isSelectAllShowPopUp) {
        toggleSelectAllShowPopUp(true);
      } else {
        toggleSelectAllCheckBox(true);
        toggleAllCustomers(true);
        toggleSelectAllShowPopUp(false);
      }
    } else {
      toggleSelectAllCheckBox(true);
      toggleAllCustomers(true);
    }
  };

  const unSelectAll = () => {
    toggleSelectAllCheckBox(true);
    toggleAllCustomers(true);
  };

  const toggleAllCustomers = (flag) => {
    const count = flag ? selectedCustomers.items.length : 0;
    const newData = selectedCustomers.items.map((customer) => {
      return {
        ...customer,
        checked: flag,
      };
    });
    toggleSelected({...selectedCustomers, items: newData, count: count});
  };

  const returnAndSelectAllCustomers = () => {
    gaReportOnButtonClick('select_customers_page_select_all_btn');
    saveSelectedCustomers(selectedCustomers, true);
  };

  const searchCustomers = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (value != '') {
      var results = lodash.filter(selectedCustomers.items, function (item) {
        if (item.number?.substring(0, value.length).indexOf(value) > -1) {
          return item.number.substring(0, value.length).indexOf(value) > -1;
        } else if (item.name?.substring(0, value.length).indexOf(value) > -1) {
          return item.name.substring(0, value.length).indexOf(value) > -1;
        } else return null;
      });
      setFilteredCustomers(results);
    } else {
      setFilteredCustomers([]);
    }
  };
  const closeSelecting = () => {
    let changes = lodash.isEqual(customersList, selectedCustomers.items);
    if (!changes) {
      if (!isCloseAllShowPopUp) {
        toggleCloseAllShowPopUp(true);
      }
    } else {
      saveSelectedCustomers(customersList, false);
    }
  };

  const closeModal = () => {
    if (isSelectAllShowPopUp) toggleSelectAllShowPopUp(false);
    else toggleCloseAllShowPopUp(false);
  };
  const clearSearchValue = () => {
    setSearchValue('');
    setFilteredCustomers([]);
  };

  const gaAndToggleSelecting = (status) => {
    if (isBusinessBlock) {
      gaReportOnButtonClick('select_customers_page_select_activation');
    }

    toggleSelecting(status);
  };

  const searchFocusGAEvent = () => {
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_SEARCH.category,
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_SEARCH.eventType,
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_SEARCH.eventParams,
    );
  };

  function closePopUp() {
    setIsPrivateFlow(false);
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    saveSelectedCustomers(selectedCustomers, false);
  }

  function gaAndSaveSelectedCustomers(selectedCustomers, all) {
    gaPopupBanSelectingContinueButtonClickedPrivate();
    saveSelectedCustomers(selectedCustomers, all);
  }

  function renderByUserSegment() {
    if (!isBusinessBlock) {
      return (
        <div className='payment-box-card'>
          <div className='payment-method-card'>
            <div className='payment-box-card__header'>
              <div className='header-content'>
                <div className='payment-info'>
                  <Image src={images.differentpayment} alt='Credit Card' className='card-icon-image' />
                  <span className='card-number bold'>{paymentMethod}</span>
                </div>
              </div>
            </div>
            <div className='accounts-section'>
              <span className='accounts-counter'>מוגדר ב-{selectedCustomers.items.length} חשבונות </span>
              <div className='accounts-header'>
                <i className='fas fa-chevron-down dropdown-icon'></i>
              </div>
              <div className='accounts-list'>
                {selectedCustomers.items.map((customer, index) => {
                  return (
                    <CustomerItemComponent
                      checked={customer.checked ? 'checked' : ''}
                      number={customer.number}
                      name={customer.name}
                      id={customer.id}
                      key={index}
                      isSelecting={isSelecting}
                      subcustomers={customer.subCustomers}
                      onToggleCheckBox={() => onToggleCheckBox(customer.id)}
                      filtering={false}
                      propsUpdateSlice={props.props}
                    />
                  );
                })}

                {filteredCustomers.length > 0 && (
                  <div className='filtered-wrapper'>
                    {filteredCustomers.map((customer, index) => {
                      let checked = selectedCustomers.items.find((c) => c.id == customer.id).checked;
                      return (
                        <CustomerItemComponent
                          checked={checked ? 'checked' : ''}
                          number={customer.number}
                          name={customer.name}
                          id={customer.id}
                          key={index}
                          isSelecting={isSelecting}
                          searchValue={searchValue}
                          onToggleCheckBox={() => onToggleCheckBox(customer.id)}
                          filtering={true}
                          propsUpdateSlice={props.props}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='button-container'>
            <Row className={`${isMobile ? 'negative-margin-top mt-n1' : ''}`}>
              <Col xs={12} className='m-auto save-button text-center btn-337 mt-20'>
                {selectedCustomers.count >= 0 && (
                  <BtnSubmit
                    isBusiness={isBusinessBlock}
                    text='אפשר להמשיך'
                    onclick={() => gaAndSaveSelectedCustomers(selectedCustomers, false)}
                  />
                )}
              </Col>
            </Row>
          </div>
        </div>
      );
    } else {
      const isSearchEmpty = searchValue.trim() === '';
      const searchIconToUse = isSearchEmpty ? searchIcons : clearIcons;
      return (
        <Fragment>
          <div className='top-part'>
            <button onClick={() => closeSelecting()} className='close-btn' style={{ backgroundImage: backgroundImageFromIcons(closeIcons) }}></button>
            <div className='top-part-content'>
              <p className='bold mb-0'>עדכון חשבונות המשוייכים לאמצעי תשלום</p>
              <p className='mb-0'>{paymentMethod}</p>
              <p className='mb-0'>{hiddenNumber}</p>
            </div>
          </div>
          <div className={`background-container middle-part`}>
            <div className={`${isSelecting ? 'hidden-box-shadow' : ''} middle-part-content`}>
              {!isSelecting ? (
                <Col className={`${isMobile ? 'p-0' : ''} middle-part-content-btns`}>
                  <p className='bold text-center'>אפשר לעדכן את אמצעי התשלום בכל החשבונות או רק בחלק מהם</p>
                  <Row>
                    <Col xs={5}>
                      <BtnSubmit isBusiness={isBusinessBlock} text='לעדכן בכולם' onclick={returnAndSelectAllCustomers} />
                    </Col>
                    <Col xs={7}>
                      <BtnSubmit isBusiness={isBusinessBlock} text='לבחור חשבונות לעדכון' onclick={() => gaAndToggleSelecting(true)} />
                    </Col>
                  </Row>
                </Col>
              ) : (
                <Row className='animateIn middle-part-content-btns'>
                  <Col xs={4} className={`${filteredCustomers.length > 0 ? 'disabled' : ''}`}>
                    <CheckBox
                      checked={selectAllCheckBox}
                      label={'בחר/נקה הכל'}
                      id={'all'}
                      onCheck={() => selectAll()}
                      onUncheck={() => {
                        unSelectAll();
                      }}></CheckBox>
                  </Col>
                  <Col xs={8} className='search-area'>
                    <TextInput
                      value={searchValue}
                      name='search'
                      type='text'
                      placeholder='חיפוש לפי מספר או שם חשבון'
                      onChange={searchCustomers}
                      onFocus={() => {
                        searchFocusGAEvent();
                      }}
                    />
                    <Button
                      color='link'
                      style={{
                        backgroundImage: backgroundImageFromIcons(searchIconToUse),
                      }}
                      className={`${isSearchEmpty ? 'search' : 'clear'} search-input`}
                      onClick={() => clearSearchValue()}
                    />
                  </Col>
                </Row>
              )}
            </div>
            <div className={`middle-customers-part ${isSelecting ? 'active-celecting' : ''}`}>
              <div className={`${filteredCustomers.length > 0 ? 'serene' : ''}`}>
                {selectedCustomers.items.map((customer, index) => {
                  return (
                    <CustomerItemComponent
                      checked={customer.checked ? 'checked' : ''}
                      number={customer.number}
                      name={customer.name}
                      id={customer.id}
                      key={index}
                      isSelecting={isSelecting}
                      subcustomers={customer.subCustomers}
                      onToggleCheckBox={() => onToggleCheckBox(customer.id)}
                      filtering={false}
                      propsUpdateSlice={props.props}
                    />
                  );
                })}
              </div>

              {filteredCustomers.length > 0 && (
                <div className='filtered-wrapper'>
                  {filteredCustomers.map((customer, index) => {
                    let checked = selectedCustomers.items.find((c) => c.id == customer.id).checked;

                    return (
                      <CustomerItemComponent
                        checked={checked ? 'checked' : ''}
                        number={customer.number}
                        name={customer.name}
                        id={customer.id}
                        key={index}
                        isSelecting={isSelecting}
                        searchValue={searchValue}
                        onToggleCheckBox={() => onToggleCheckBox(customer.id)}
                        filtering={true}
                        propsUpdateSlice={props.props}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          <div className='bottom-part'>
            <Row>
              <Col xs={12} className='m-auto save-button text-center btn-337'>
                {selectedCustomers.count > 0 && (
                  <BtnSubmit
                    isBusiness={isBusinessBlock}
                    text='אפשר להמשיך'
                    onclick={() => saveSelectedCustomers(selectedCustomers, false)}
                  />
                )}
              </Col>
            </Row>
          </div>

          <PopUp showPopUp={isSelectAllShowPopUp} onClose={() => closeModal()}>
            <PopupContent
              buttonFunction={selectAll}
              closeModal={closeModal}
              title='שניה לפני...'
              cancelBtnText='אוקיי, אל תסירו'
              btnText='בסדר, אפשר להמשיך'
              isBusiness={isBusinessBlock}
            />
          </PopUp>
          <PopUp showPopUp={isCloseAllShowPopUp} onClose={() => closeModal()}>
            <PopupContent
              buttonFunction={() => saveSelectedCustomers(customersList, false)}
              closeModal={closeModal}
              title='שניה לפני...'
              btnText='אפשר לסגור'
              cancelBtnText='טוב ששאלתם, אל תסגרו'
              isBusiness={isBusinessBlock}
            />
          </PopUp>
        </Fragment>
      );
    }
  }

  return renderByUserSegment();
};
export default AllCustomersComponent;
